var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-select',{attrs:{"options":_vm.options,"disabled":_vm.readonly},model:{value:(_vm.compValue),callback:function ($$v) {_vm.compValue=$$v},expression:"compValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }